import { CCollapse } from '@coreui/react';
import React from 'react';
import { useSelector } from 'react-redux';
import CenterSpinner from './Loadings/CenterSpinner';
import PropTypes from 'prop-types';

const Accordion = ({ accordionShow, setAccordionShow, accordionType, title, description, isLoading, children, className, classNameBody }) => {
     const listenersLoading = useSelector((state) => state.subscriber.loadings.listeners);
     if (!isLoading) {
          isLoading = listenersLoading;
     }

     return (
          <div className={`accordion-item${accordionShow === accordionType ? ' show' : ''} ${className || ''}`}>
               <button type='button' className='accordion-header' onClick={() => setAccordionShow(accordionShow === accordionType ? null : accordionType)}>
                    <strong className='title'>{title}</strong>
                    {description && <p className='description'>{description}</p>}
               </button>
               <CCollapse visible={accordionShow === accordionType}>
                    <div className={`accordion-body ${classNameBody || ''}`}>{isLoading ? <CenterSpinner /> : children}</div>
               </CCollapse>
          </div>
     );
};


Accordion.propTypes = {
     setAccordionShow: PropTypes.func,
     isLoading: PropTypes.bool,
     title: PropTypes.string,
     classNameBody: PropTypes.any,
     children: PropTypes.node,
     description: PropTypes.string,
     accordionType: PropTypes.string,
     accordionShow: PropTypes.any,
     className: PropTypes.string,
};

export default Accordion;
